import { startFlowPlugin } from './start_flow';

const PLUGINS = [startFlowPlugin];

/**
 * Registers every plugin bundled with the chat. Must run before the panel mounts:
 * the registry is not reactive, so anything registered later is not picked up.
 *
 * @param {import('../services/plugin_registry').DuoChatPluginRegistry} registry
 */
export function initializePlugins(registry) {
  PLUGINS.forEach((plugin) => registry.registerPlugin(plugin));
}
